import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { BasicAuth } from './basic-auth.provider';
import { FirestoreProvider } from '../firestore/firestore.provider';
import { SessionStorageProvider } from '../../session-storage/session-storage.provider';

@Injectable()
export class AuthProvider implements BasicAuth {
  private currentUser: firebase.User;

  constructor(
    public firestoreProvider: FirestoreProvider,
    public sessionStorageProvider: SessionStorageProvider
  ) {
    firebase.auth().onAuthStateChanged((user: firebase.User) => {
      this.currentUser = user;
      if (this.currentUser) {
        this.storageUserToken();
      } else {
        this.sessionStorageProvider.removeItem('currentUser-token');
      }
    });
  }

  storageUserToken() {
    this.currentUser.getIdToken().then(token => {
      this.sessionStorageProvider.setItem('currentUser-token', token);
    });
  }

  getAuth() {
    return firebase.auth();
  }

  isAuthenticated() {
    return this.currentUser != null;
  }

  getUserId() {
    return this.currentUser.uid;
  }

  getUserName() {
    return this.currentUser.displayName;
  }

  getUserEmail() {
    return this.currentUser.email;
  }

  signInWithEmailAndPassword(email: string, password: string) {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }

  signUpWithEmailAndPassword(email: string, password: string) {
    return firebase.auth().createUserWithEmailAndPassword(email, password);
  }

  updateUserProfile(profile: any) {
    return this.currentUser.updateProfile(profile);
  }

  resetPassword(email: string) {
    return firebase.auth().sendPasswordResetEmail(email);
  }

  signOut() {
    return firebase.auth().signOut();
  }
}
